<script lang="ts" setup>
const { logOut } = useLogOut()
const userContext = useUserContext()
const menu = ref(false)
const user = computed(() => userContext.user.value)
const leadRole = computed(() => userContext.leadRole.value)
const username = computed(() => encodeURIComponent(user.value.name ?? "Default User"))
const doLogOut = async () => {
	await logOut()
}
</script>

<template>
	<BaseMenu v-if="user" v-model="menu" :open-on-hover="false">
		<template #activator="{ props }">
			<picture data-cy="user-menu"
				class="h-9 w-9 rounded-full ring-2 ring-transparent hover:ring-primary/40 transition cursor-pointer block"
				v-bind="props">
				<source id="s1"
					:srcset="user.image || `https://ui-avatars.com/api/?name=${username}&background=0D8ABC&color=fff&rounded=true`">
				<img class="h-9 w-9 rounded-full"
					:src="`https://ui-avatars.com/api/?name=${username}&background=0D8ABC&color=fff&rounded=true`"
					alt="" onerror="this.onerror=null;document.getElementById('s1').srcset=this.src;">
			</picture>
		</template>

		<UCard class="min-w-64 overflow-hidden" :ui="{ header: 'p-0 sm:p-0', body: 'p-4 sm:p-4' }">
			<template #header>
				<div class="bg-gradient-to-br from-primary/10 via-secondary/5 to-transparent px-4 py-3">
					<div class="font-semibold text-default truncate">{{ user.email }}</div>
					<div class="text-muted text-xs mt-0.5 uppercase tracking-wider font-medium">{{ leadRole }}</div>
				</div>
			</template>
			<div class="flex justify-between items-center gap-x-4">
				<NuxtLink class="flex items-center gap-2 text-sm text-default hover:text-primary transition-colors"
					:to="'/settings'">
					<UIcon name="i-mdi-cog-outline" class="text-base" />
					<span>{{ $t("navigation.settings") }}</span>
				</NuxtLink>
				<UButton leading-icon="i-mdi-logout" color="primary" variant="soft" data-cy="logout" @click="doLogOut">
					<div>{{ $t("common.logout") }}</div>
				</UButton>
			</div>
		</UCard>
	</BaseMenu>
</template>
